<div>
  <div class="flex flex-row mt-3">
    <div class="flex-auto">
      <mat-accordion>
        <div class="mt-2">
          <form [formGroup]="searchForm">
            <div class="flex items-center gap-2 mt-1">
              <div class="flex-1">
                <app-dropdown-search-single-select
                  id="rawMaterialTypeDropdown"
                  label="{{ translationService.translate('searchByRawMaterialTypeText') }}"
                  emptyPlaceholder="{{ translationService.translate('searchByRawMaterialTypeText') }}"
                  placeholder="{{ translationService.translate('searchByRawMaterialTypeText') }}"
                  [formGroup]="searchForm"
                  formControlName="rawMaterialType"
                  [data]="rawMaterialTypeOptions"
                >
                </app-dropdown-search-single-select>
              </div>

              <div class="flex-1">
                <app-dropdown-search-single-select
                  id="serialNumberDropdown"
                  label="{{ translationService.translate('searchBySerialNumberText') }}"
                  emptyPlaceholder="{{ translationService.translate('searchBySerialNumberText') }}"
                  placeholder="{{ translationService.translate('searchBySerialNumberText') }}"
                  [formGroup]="searchForm"
                  formControlName="serialNumber"
                  [data]="serialNumberOptions"
                >
                </app-dropdown-search-single-select>
              </div>

              <div class="flex-1">
                <app-dropdown-search-single-select
                  id="descriptionDropdown"
                  label="{{ translationService.translate('searchByDescText') }}"
                  emptyPlaceholder="{{ translationService.translate('searchByDescText') }}"
                  placeholder="{{ translationService.translate('searchByDescText') }}"
                  [formGroup]="searchForm"
                  formControlName="description"
                  [data]="rawMaterialStockOptions"
                >
                </app-dropdown-search-single-select>
              </div>

              <div class="flex-1">
                <app-dropdown-search-single-select
                  id="stockMovementTypeDropdown"
                  label="{{ translationService.translate('searchByStockMovementTypeText') }}"
                  emptyPlaceholder="{{ translationService.translate('searchByStockMovementTypeText') }}"
                  placeholder="{{ translationService.translate('searchByStockMovementTypeText') }}"
                  [formGroup]="searchForm"
                  formControlName="stockMovementType"
                  [data]="stockMovementTypeOptions"
                >
                </app-dropdown-search-single-select>
              </div>

              <div class="flex-1">
                <app-dropdown-search-single-select
                  id="plantDropdown"
                  label="{{ translationService.translate('searchByPlantText') }}"
                  emptyPlaceholder="{{ translationService.translate('searchByPlantText') }}"
                  placeholder="{{ translationService.translate('searchByPlantText') }}"
                  [formGroup]="searchForm"
                  formControlName="plant"
                  [data]="plantOptionsFormatted"
                >
                </app-dropdown-search-single-select>
              </div>

              <div class="search-action-col">
                <button
                  id="clear-selection-button"
                  mat-flat-button
                  color="accent"
                  class="mic-btn-icon-left"
                  type="button"
                  (click)="clearSelection()"
                  title="{{ translationService.translate('clearSelectionText') }}"
                >
                  <mat-icon>refresh</mat-icon>
                  <span>{{ translationService.translate('clearSelectionText') }}</span>
                </button>
              </div>
            </div>
          </form>

          <!-- Stock Movement History Table -->
          <div id="stock-movement-history-table" class="cam-table table-container btn-table mt-4">
            <mic-table class="table-stripped" [config]="tableConfig" [fetcher]="fetcher">
              <ng-container *micTableNoData>
                <mic-empty-state icon="inventory_2" title="{{ translationService.translate('No stock movements found') }}">
                  <p>{{ translationService.translate('Try adjusting your search criteria') }}</p>
                </mic-empty-state>
              </ng-container>
            </mic-table>
          </div>
        </div>
      </mat-accordion>
    </div>
  </div>
</div>
